import { ref, reactive } from 'vue';

interface SnackbarState {
  visible: boolean;
  message: string;
  color: string;
}

interface SnackbarPayload {
  message: string;
  color: string;
}

// Create a reactive state that will be shared across all component instances
const snackbarState = reactive<SnackbarState>({
  visible: false,
  message: '',
  color: '',
});

export function useSnackbar() {
  const showSnackbar = (payload: SnackbarPayload) => {
    snackbarState.message = payload.message;
    snackbarState.color = payload.color;
    snackbarState.visible = true;
  };

  const closeSnackbar = () => {
    snackbarState.visible = false;
  };

  return {
    snackbarState,
    showSnackbar,
    closeSnackbar,
  };
} 